import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';

import { ErrorState } from '@nucleus-commerce/admin-kit/errors';

import { session } from '@/shared/session/session';

import { routeTree } from '../routeTree.gen';

import { queryClient } from './query-client';

export interface RouterContext {
  queryClient: QueryClient;
  session: typeof session;
}

export const router = createRouter({
  routeTree,
  context: { queryClient, session },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0, // TanStack Query owns staleness
  scrollRestoration: true,
  defaultPendingMinMs: 200,
  defaultErrorComponent: ({ error, reset }) => (
    <div className="p-6">
      <ErrorState error={error} onRetry={reset} />
    </div>
  ),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    /** i18n key for the breadcrumb trail; a loader may return `{ crumb }` for a record title instead. */
    crumb?: string;
  }
}
